import React from 'react';
import PropTypes from 'prop-types';
// import makeRequest from 'utils/makeRequest';
// import _get from 'lodash.get';
// import { connect } from 'react-redux';
// import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  // disableBodyScroll,
  // getBrowserName,
  // isTablet,
  // fireCustomDimension,
  getQueryParams,
} from 'utils/common';
import {
  // checkGracePeriod,
  // getPreExpiryFormattedTime,
  // checkNewUser,
  getGeoCountry,
  // checkPreExpireDate,
} from 'utils/primeUtil';
// import { loginEventEmitter } from 'components/Login';
// import useFetch from 'utils/hooks/useFetch';
import // TOI_SUBS_FETCH_PLANS_MWEB,
// TOI_SUBS_FETCH_PLANS_WEB,
// PRC_FOR_FTU,
// PRC_FOR_SUBSCRIBED,
// TOI_SUBS_FETCH_PLAN_STATUS_WEB,
// TOI_SUBS_FETCH_PLAN_STATUS_MWEB,
// TOI_PLUS_PLAN_PAGE_URL,
'constants/index';
// import Cookie from 'utils/cookies';
// import GstAdressCapture from 'components_v2/common/ToiplusForms/GstAddressCapture.tsx';
// eslint-disable-next-line import/no-named-as-default
// import BROWSER_STORAGE_KEY from './config';
import ToiSubscriptionStatus from './Common/ToiSubscriptionStatus/ToiSubscriptionStatus';
// import { loadPaymentSdk, choosePlanAndInitiatePayment } from './utils/payment';
// import s from '../ToiSubscription/Common/ToiSubscriptionStatus/ToiSubscriptionStatus.scss';

const ToiSubscriptionFlowCaller = props => {
  const {
    // query,
    msid,
    storyTitle,
    // hasGSTFormFilled,
    // userPrcData,
    // startGstFlowNode,
  } = props;
  // const [screen, setScreen] = useState('');
  // const gstFormGaFired = useRef(false);
  // const [prcStatusDetails, setPrcStatusDetails] = useState({
  //   gstFormFilled: false,
  // });
  // const [userPhone, setUserPhone] = useState(undefined);
  // const [showLoader, setShowLoader] = useState(false);
  // const [shouldOpenGST, setShouldOpenGST] = useState(false);
  // const [planPageView, setPlanPageView] = useState(false);
  // const [inGracePeriod, setInGracePeriod] = useState(false);
  // const [inPreExpirePeriod, setInPreExpirePeriod] = useState(false);
  // const [userType, setUserType] = useState('');
  // const [remainingDays, setRemainingDays] = useState(-1);
  const geoCountry = getGeoCountry();
  // const { response: subscriptionsRes } = useFetch({
  //   url: `${
  //     props.isWapView ? TOI_SUBS_FETCH_PLANS_MWEB : TOI_SUBS_FETCH_PLANS_WEB
  //   }&cc=${geoCountry}&listView=true`,
  // });
  // const { post: getPaymentInitData, response: initPaymentRes } = useFetch({});
  // const { post: createOrder } = useFetch({});
  const { userData, isWapView, currencyCode } = props;
  // const userid = userData && userData.getUid ? userData.getUid() : '';
  // const prc = userData && userData.prcValue ? userData.prcValue : 0;
  // const getPrcDataAPI = () => {
  //   if (userData && userData.isLoggedIn) {
  //     let ticketId = document.cookie.match(/(?:\s)?TicketId=(\w+);?/);
  //     ticketId = Array.isArray(ticketId) && ticketId[1];
  //     let ssoId = document.cookie.match(/(?:\s)?ssoid=(\w+);?/);
  //     ssoId = Array.isArray(ssoId) && ssoId[1];
  //     const userPhoneFromSessionStorage = sessionStorage.getItem('userPhone');
  //     if (userPhoneFromSessionStorage) {
  //       setUserPhone(userPhoneFromSessionStorage);
  //     }
  //     const url = isWapView
  //       ? TOI_SUBS_FETCH_PLAN_STATUS_MWEB
  //       : TOI_SUBS_FETCH_PLAN_STATUS_WEB;
  //     return makeRequest.get(url, {
  //       headers: {
  //         ticketId,
  //         ssoId,
  //       },
  //       params: {
  //         rspBody: true,
  //       },
  //     });
  //   }
  //   return null;
  // };

  // const getPrcData = () => {
  //   //if (userData && userData.isLoggedIn) {
  //   if (props.userPrcData) {
  //     setPrcStatusDetails({
  //       ...props.userPrcData,
  //       gstFormFilled: hasGSTFormFilled,
  //     });
  //   }
  // };

  const getCachedOrderId = () => {
    let transcode = '';
    if (typeof window !== 'undefined') {
      transcode = getQueryParams('transcode');
    }
    return transcode;
  };

  // const showPaymentStatus = () => {
  //   const storedPlanOption = JSON.parse(localStorage.getItem('planOption'));
  //   const orderId =
  //     getCachedOrderId() || window.location.href.indexOf('transcode') > -1;
  //   if (
  //     ((storedPlanOption === 'credOption' || orderId?.length > -1) &&
  //       (localStorage.getItem(BROWSER_STORAGE_KEY) ||
  //         localStorage.getItem('cred_login_failure'))) ||
  //     localStorage.getItem('paymentSuccess')
  //   ) {
  //     sessionStorage.removeItem('already_prime_user');
  //     // setShowLoader(true);
  //     // setScreen('paymentStatus');
  //   }
  // };

  // const hideLoader = () => {
  //   // setShowLoader(false);
  // };

  // const viewLoader = () => {
  //   // setShowLoader(true);
  // };

  // const getPlanId = () => {
  //   let planId = 6;
  //   const { data: { data: { plans } } } = subscriptionsRes;
  //   if (Array.isArray(plans) && plans.length > 0) {
  //     if (plans[0].subscription?.name === 'TOI+') {
  //       planId = plans[0].planId;
  //     }
  //   }
  //   return planId;
  // };
  // const startTOIPaymentFlow = (planId, accessType) => {
  //   userData.isLoggedIn = true;
  //   const getPrcDataAPIPromise = getPrcDataAPI();
  //   if (getPrcDataAPIPromise) {
  //     getPrcDataAPIPromise.then(data => {
  //       if (
  //         data &&
  //         data.status === 200 &&
  //         data.data &&
  //         typeof data.data === 'object'
  //       ) {
  //         const prcData = data.data;
  //         if (prcData) {
  //           if (accessType === 'PAY_PER_ARTICLE') {
  //             choosePlanAndInitiatePayment(
  //               null,
  //               getPaymentInitData,
  //               initPaymentRes,
  //               createOrder,
  //               prcData.planStatus,
  //               isWapView,
  //               geoCountry,
  //               currencyCode,
  //               msid,
  //               { accessType: prcData.accessType },
  //             );
  //           } else {
  //             choosePlanAndInitiatePayment(
  //               planId,
  //               getPaymentInitData,
  //               initPaymentRes,
  //               createOrder,
  //               prcData.planStatus,
  //               isWapView,
  //               geoCountry,
  //               currencyCode,
  //               null,
  //               {
  //                 inPreExpirePeriod,
  //                 inGracePeriod,
  //                 userType,
  //                 remainingDays,
  //                 accessType: prcData.accessType,
  //               },
  //             );
  //           }
  //         }
  //       }
  //     });
  //   }
  // };

  // const subscriptionFlowHandler = evt => {
  //   const { screenType } = evt.detail;
  //   const isUserLoggedin = userData.isLoggedIn;

  //   if (screenType === 'planScreen') {
  //     setScreen('planScreen');

  //     disableBodyScroll();
  //   } else if (screenType === 'paymentScreen') {
  //     loadPaymentSdk();
  //     if (isUserLoggedin) {
  //       if (prcStatusDetails?.planStatus && prcStatusDetails?.accessType) {
  //         choosePlanAndInitiatePayment(
  //           getPlanId(),
  //           getPaymentInitData,
  //           initPaymentRes,
  //           createOrder,
  //           prcStatusDetails.planStatus,
  //           isWapView,
  //           geoCountry,
  //           currencyCode,
  //           null,
  //           {
  //             inPreExpirePeriod,
  //             inGracePeriod,
  //             userType,
  //             remainingDays,
  //             accessType: prcStatusDetails.accessType,
  //           },
  //         );
  //       }
  //     } else {
  //       loginEventEmitter(startTOIPaymentFlow, {
  //         showToiSubscriptionText: true,
  //         isPrimePaymentFlow: true,
  //       });
  //     }
  //   }
  // };

  // const triggerMailOnContactUs = (subjectPreTxt, orderId, triggerPage) => {
  //   if (typeof window !== 'undefined') {
  //     const ssoId = Cookie.get('ssoid') || Cookie.get('ssoId');
  //     let device = 'Desktop';
  //     if (isWapView) {
  //       device = 'MWeb';
  //     } else if (isTablet()) {
  //       device = 'tablet';
  //     }
  //     let email = '';
  //     if (userData && typeof userData === 'object' && userData.getEmail)
  //       email = userData.getEmail();
  //     if (email) {
  //       email = `%0D%0AUser Email: ${email}`;
  //     } else {
  //       email = '';
  //     }
  //     let phone = userPhone;
  //     if (phone) {
  //       phone = `%0D%0AUser phone: ${phone}`;
  //     } else {
  //       phone = '';
  //     }
  //     const browser = getBrowserName();
  //     const userIdSub = ssoId ? `| userId: ${ssoId}` : '';
  //     const userIdBody = ssoId ? `%0D%0AUser ID: ${ssoId}` : '';
  //     const orderIdSub = orderId ? `| OrderId: ${orderId}` : '';
  //     const orderIdBody = orderId ? `%0D%0AOrder ID: ${orderId}` : '';
  //     const mail = `mailto:toipluscare@timesinternet.in?subject=${subjectPreTxt} | ${device} | ${browser} ${userIdSub} ${orderIdSub}
  //     &body=%0D%0A%0D%0A-----------------------%0D%0APlease type your email above the line, below information is needed to address your issue in more detail.%0D%0APlease do not delete/modify this information.%0D%0A%0D%0ADevice: ${device}%0D%0ABrowser: ${browser}${userIdBody}${email}${phone}%0D%0ATrigger Page: ${triggerPage}${orderIdBody}%0D%0A`;
  //     window.location.href = mail;
  //   }
  // };

  // useEffect(
  //   () => {
  //     getPrcData();
  //   },
  //   [props.userPrcData, prc, hasGSTFormFilled],
  // );

  // const startPlanPageFlow = val => {
  //   setPlanPageView(val);
  // };

  // useEffect(
  //   () => {
  //     if (
  //       query?.pageName === 'ToiPlusPlanpage' &&
  //       planPageView &&
  //       userData?.prcValue !== PRC_FOR_FTU &&
  //       userData?.prcValue !== PRC_FOR_SUBSCRIBED
  //     ) {
  //       //subscriptionFlowHandler({ detail: { screenType: 'planScreen' } });
  //       window.location.href = TOI_PLUS_PLAN_PAGE_URL;
  //     }
  //   },
  //   [planPageView],
  // );

  // useEffect(() => {
  //   window.addEventListener('load', startPlanPageFlow.bind(this, true));
  //   return () => {
  //     window.removeEventListener('load', () => {});
  //   };
  // }, []);

  // useEffect(
  //   () => {
  //     window.addEventListener(
  //       'toi_subscriptionflow_start',
  //       subscriptionFlowHandler,
  //     );

  //     return () => {
  //       window.removeEventListener(
  //         'toi_subscriptionflow_start',
  //         subscriptionFlowHandler,
  //       );
  //     };
  //   },
  //   [subscriptionFlowHandler, props.userPrcData],
  // );

  // useEffect(
  //   () => {
  //     if (props.userPrcData) {
  //       getPreExpiryFormattedTime(props.userPrcData).then(res => {
  //         setRemainingDays(res);
  //       });
  //       // checkNewUser(props.userPrcData).then(res => {
  //       //   setUserType(res);
  //       // });
  //       checkGracePeriod(props.userPrcData).then(res => {
  //         setInGracePeriod(res);
  //       });
  //       checkPreExpireDate(props.userPrcData).then(res => {
  //         setInPreExpirePeriod(res);
  //       });
  //     }
  //   },
  //   [props.userPrcData],
  // );

  // useEffect(() => {
  //   showPaymentStatus();
  // }, []);

  // if (screen === 'planScreen') {
  //   if (typeof window !== 'undefined') {
  //     fireCustomDimension(currencyCode, 'dimension38');
  //     analyticsWrapper(
  //       'gaAndGrx',
  //       'send',
  //       'event',
  //       window.categoryForGA,
  //       `TOIPlus_PlanPage_View`,
  //       `Ps-${userData && userData.isLoggedIn ? userData.prcValue : -1}`,
  //     );
  //     window.location.href = TOI_PLUS_PLAN_PAGE_URL;
  //   }
  // } else
  // if (true) {
  // let cachedOrderId = '';
  // if (typeof window !== 'undefined') {
  //   // cachedOrderId = getCachedOrderId();

  //   if (
  //     // !gstFormGaFired.current &&
  //     // hasGSTFormFilled &&
  //     userPrcData?.planStatus &&
  //     userPrcData?.accessType
  //   ) {
  //     analyticsWrapper(
  //       'ga',
  //       'send',
  //       'event',
  //       'TOIPlus_Addressform',
  //       `Address_update_form_submit`,
  //       `Ps-${userPrcData.planStatus}/${userPrcData.accessType}`,
  //     );
  //     gstFormGaFired.current = true;
  //   }
  // }
  // const callbackReturnforGST = () => {
  //   // setShouldOpenGST(val);
  //   // setShowLoader(true);
  //   setScreen('paymentStatus');
  // };

  // const gstFormClosedByUser = !!(
  //   sessionStorage && sessionStorage.getItem('gstFormClosedByUser')
  // );

  return (
    <>
      {getCachedOrderId() && (
        <>
          {/* {showLoader &&
              !gstFormClosedByUser &&
              (!shouldOpenGST && !hasGSTFormFilled) && (
                <div className={`${s.overlay_bg} ${s.active}`}>
                  <div className={s.common_blocker_subs}>
                    <div className={`${s.loader_case} ${s.status_content}`}>
                      <div className={s.loading_spinner} />
                    </div>
                  </div>
                </div>
              )} */}
          <ToiSubscriptionStatus
            userData={userData}
            // prcStatusDetails={prcStatusDetails}
            // startTOIPaymentFlow={startTOIPaymentFlow}
            // triggerMailOnContactUs={triggerMailOnContactUs}
            // userPhone={userPhone}
            // hideLoader={hideLoader}
            isWapView={isWapView}
            currencyCode={currencyCode}
            geoCountry={geoCountry}
            msid={msid}
            storyTitle={storyTitle}
            // viewLoader={viewLoader}
            // inPreExpirePeriod={inPreExpirePeriod}
            // inGracePeriod={inGracePeriod}
            // remainingDays={remainingDays}
            // hasGSTFormFilled={prcStatusDetails.gstFormFilled}
            // callback={callbackReturnforGST}
            // startGstFlowNode={startGstFlowNode}
          />
        </>
      )}
      {/* // true && ((false && false) || (true && true)) */}
      {/* {!hasGSTFormFilled &&
          ((shouldOpenGST && getCachedOrderId()) ||
            (!getCachedOrderId() &&
              userPrcData &&
              userPrcData?.gstAddressUpdateRequired)) && (
            <GstAdressCapture
              cachedOrderId={cachedOrderId}
              geoCountry={geoCountry}
              userPrcData={userPrcData}
            />
          )} */}
    </>
  );
  // else if (
  //   !getCachedOrderId() &&
  //   !hasGSTFormFilled &&
  //   userPrcData &&
  //   userPrcData?.gstAddressUpdateRequired
  // ) {
  //   return (
  //     <GstAdressCapture geoCountry={geoCountry} userPrcData={userPrcData} />
  //   );
  // }
  // return null;
};

ToiSubscriptionFlowCaller.propTypes = {
  isWapView: PropTypes.bool.isRequired,
  userData: PropTypes.shape({
    prcValue: PropTypes.number,
    isLoggedIn: PropTypes.bool,
    getEmail: PropTypes.func,
    getUid: PropTypes.func,
  }),
  currencyCode: PropTypes.string,
  // query: PropTypes.isRequired,
  msid: PropTypes.number,
  storyTitle: PropTypes.string,
  userPrcData: PropTypes.shape({}),
  // hasGSTFormFilled: PropTypes.bool,
  // startGstFlowNode: PropTypes.bool,
};

ToiSubscriptionFlowCaller.defaultProps = {
  userData: {},
  currencyCode: '',
  msid: '',
  storyTitle: '',
  userPrcData: {},
  // hasGSTFormFilled: false,
  // startGstFlowNode: false,
};

// const mapStateToProps = state => ({
// hasGSTFormFilled: state.gstform?.hasPostGSTFormData,
// userPrcData: state?.login?.userPrcData,
// startGstFlowNode: _get(
//   state?.translationConfig?.nudges,
//   'gstForm.startGstFlow',
//   false,
// ),
// });

export default ToiSubscriptionFlowCaller;
